import React from "react"
import { css } from "emotion"

function Unauthorised() {
  return (
    <div
      className={css`
        width: 100%;
        display: flex;
      `}
    >
      <div>{"Unauthorised"}</div>
    </div>
  )
}

export default Unauthorised
